import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import DashBoardLayerOne from "../components/DashBoardLayerOne";
import { getLoggedInUser } from "../utils/auth";

const HomePageOne = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = getLoggedInUser();
    if (user?.role?.toLowerCase() === "operator") {
      navigate("/operator-files");
    }
  }, [navigate]);

  return (
    <MasterLayout>
      <DashBoardLayerOne />
    </MasterLayout>
  );
};

export default HomePageOne;
